import axiosInstance from './axios-instance';

export const changeMasterPassword = (currentPassword: string, newPassword: string) =>
  axiosInstance.post('master/password;changed', { currentPassword, newPassword });

export const resendRegistrationConfirmation = () => axiosInstance.get('master/registration-confirmation;resent');

export const changeNotifications = (notifications: Record<string, boolean>) =>
  axiosInstance.put('master/notifications', notifications);
